import { useEffect, useState } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton } from '../../../common/Buttons/Buttons';
import { paymentType } from '../../../../assets/helpers/options';
import {
  PaymentsTable,
  PendingPaymentsTable,
} from '../../../common/Tables/Tables';
import {
  paymentsTableHeader,
  pendingPaymentsTableHeader,
  casheaPaymentsTableHeader,
} from '../../../../assets/helpers/tables.js';
import {
  PaymentModal,
  EditPaymentModal,
  EditPaymentDuesModal,
  AddPaymentModal,
} from '../../../common/Modals/Modals';
import { paymentsService } from '../../../../services/paymentsService';
import { rateService } from '../../../../services/rateService';
import { productService } from '../../../../services/productService';
import { currencyRateService } from '../../../../services/currencyRateService';
import { notify } from '../../../../assets/helpers/toast';
import {
  MethodValidation,
  getCorrectDate,
  NaNtoNumber,
  returnIGTF,
  isPaymentMethodZelleOrPaypal,
  getDuefromSuccessPayments,
  parseUrl,
  filterById,
  validateUpdatePaymentRefLenght,
} from '../../../../assets/helpers/funciones';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import { OderCardHeader } from './OrderComponents';
import {
  paymentTypeOptions as paymentTypesOptions,
  planStatus,
  paymentModalTypes,
  userType,
  paymentMethods as methodNames,
} from '../../../../assets/helpers/options';
import authService from '../../../../services/authService';
import { salesRoles, casheaLinkAllowedRoles } from '../../../../assets/helpers/roles';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import './OrderComponent.scss';
import { membershipService } from '../../../../services/membershipService.js';
import { bancamigaService } from '../../../../services/bancamigaService.js';
import { cashReceiverService } from '../../../../services/cashReceiverService.js';

const allowAdmin = () => {
  if ([salesRoles.SALES_ADMIN].includes(authService?.getUserType())) {
    return false;
  } else {
    return true;
  }
};

const allowEditPayment = () => {
  if (
    [salesRoles.SALES_ADMIN, salesRoles?.SALES_ADMIN_AUX].includes(
      authService?.getUserType()
    )
  ) {
    return false;
  } else {
    return true;
  }
};

export const PaymentsCard = (props) => {
  const { label, membership, reloadMembership } = props;
  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [openPayModal, setOpenPayModal] = useState(false);
  const [openEditPaymentDueModal, setOpenEditPaymentDueModal] = useState(false);
  const [openEditPaymentModal, setOpenEditPaymentModal] = useState({
    isOpen: false,
    payment: '',
  });

  const [openAddPaymentModal, setOpenAddPaymentModal] = useState(false);
  const [fileUploaded, setFileUploaded] = useState([]);
  const [returnsFilesUploaded, setReturnsFilesUploaded] = useState([]);
  const [addFilesUploaded, setAddFilesUploaded] = useState([]);
  const [dollarRate, setDollarRate] = useState('');
  const [dollarByDate, setDollarByDate] = useState('');
  const [bsDisabled, setbsDisabled] = useState(true);
  const [creationDate, setCreationDate] = useState();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [cashReceiverOptions, setCashReceiverOptions] = useState([]);

  const { setValue } = useForm({
    resolver: yupResolver(schemas.updateMembershipForm()),
  });

  const { setValue: setValue2, watch: watch2 } = useForm({
    resolver: yupResolver(schemas.updatePaymentForm()),
  });

  const history = useHistory();

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    setValue: setValue3,
    getValues: getValues3,
    resetField: resetField3,
    watch: watch3,
    reset: reset3,
    control: control3,
  } = useForm({
    resolver: yupResolver(schemas.renewMembershipSchema()),
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    setValue: setValue4,
    watch: watch4,
    reset: reset4,
    setError: setError4,
    control: control4,
  } = useForm({
    resolver: yupResolver(schemas.editPaymentSchema()),
  });

  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5, isValid: isValid5 },
    getValues: getValues5,
    setValue: setValue5,
    watch: watch5,
    reset: reset5,
    setError: setError5,
    control: control5,
  } = useForm({
    resolver: yupResolver(schemas.updatePaymentDuesSchema(membership)),
  });

  const {
    register: register6,
    handleSubmit: handleSubmit6,
    formState: { errors: errors6 },
    setValue: setValue6,
    watch: watch6,
    reset: reset6,
    getValues: getValues6,
    control: control6,
  } = useForm({
    resolver: yupResolver(schemas.addPaymentSchema()),
  });

  const {
    register: register7,
    handleSubmit: handleSubmit7,
    formState: { errors: errors7 },
    setValue: setValue7,
    watch: watch7,
  } = useForm({
    resolver: yupResolver(schemas.addinvoiceNumberSchema()),
  });

  const loadinvoiceNumber = handleSubmit7(async (data) => {
    delete data.hasInvoiceNumber;
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .loadInvoiceNumber(data, membership?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Factura actualizada`, 'success');
            reloadMembership();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const preloadForm = () => {
    // DATOS DEL PLAN
    setValue('affiliationType', membership?.affiliationType);
    setValue('contractType', membership?.contractType);
    setValue('contactInCampaign', membership?.contactInCampaign);
    // FECHAS ASOCIADAS
    setValue(
      'createdAt',
      membership?.createdAt ? getCorrectDate(membership?.createdAt) : ''
    );
    setValue(
      'beginDate',
      membership?.beginDate ? getCorrectDate(membership?.beginDate) : ''
    );
    setValue(
      'endDate',
      membership?.endDate ? getCorrectDate(membership?.endDate) : ''
    );
    setValue(
      'rcvBeginDate',
      membership?.rcvBeginDate ? getCorrectDate(membership?.rcvBeginDate) : ''
    );
    setValue(
      'rcvEndDate',
      membership?.rcvEndDate ? getCorrectDate(membership?.rcvEndDate) : ''
    );

    if (membership?.endDateFromLastMembership) {
      setValue(
        'endDateFromLastMembership',
        membership?.endDateFromLastMembership
          ? getCorrectDate(membership?.endDateFromLastMembership)
          : ''
      );
    }
    if (membership?.rcvEndDateFromLastMembership) {
      setValue(
        'rcvEndDateFromLastMembership',
        membership?.rcvEndDateFromLastMembership
          ? getCorrectDate(membership?.rcvEndDateFromLastMembership)
          : ''
      );
    }
    if (membership.invoiceNumber) {
      setValue7('hasInvoiceNumber', true);
      setValue7('invoiceNumber', membership.invoiceNumber);
    }
    // DATOS DEL PAGO
    if (membership?.membershipStatus !== 'INCOMPLETO') {
      setValue2('discountCode', membership?.discountCode);
      setValue2(
        'discountByCode',
        membership?.priceInfo?.discountByCode
          ? membership?.priceInfo?.discountByCode + ' $'
          : ''
      );

      setValue2('giftcardCode', membership?.giftcardCode);
      setValue2(
        'discountByGiftcard',
        membership?.priceInfo?.discountByGiftcard
          ? membership?.priceInfo?.discountByGiftcard + ' $'
          : ''
      );
    }

    setValue2('paymentStatus', membership?.paymentStatus);
    setValue2(
      'finalPrice',
      parseFloat(membership?.priceInfo?.finalPrice?.toFixed(2))
    );
    setValue2(
      'finalPriceInBsS',
      parseFloat(membership?.priceInfo?.finalPriceInBsS?.toFixed(2))
    );
    setValue2('paymentType', membership?.paymentType);

    if (membership?.discountCode) {
      setValue2('code', membership?.discountCode);
      setValue2('discountCode', membership?.discountCode);
      setValue2(
        'discountByCode',
        membership?.priceInfo?.discountByCode
          ? membership?.priceInfo?.discountByCode + ' $'
          : ''
      );
    }

    if (membership?.giftcardCode) {
      setValue2('giftcardCode', membership?.giftcardCode);
      setValue2(
        'discountByGiftcard',
        membership?.priceInfo?.discountByGiftcard
          ? membership?.priceInfo?.discountByGiftcard + ' $'
          : ''
      );
    }

    setValue2('paymentMethodsQuantity', membership?.payments?.length);
    if (membership?.membershipStatus === 'INCOMPLETO') {
      setValue2('paymentMethodsQuantity', 1);
    }

    if (membership?.payments?.length > 0) {
      for (let i = 0; i < membership?.payments?.length; i++) {
        setValue2(`paymentAmount${i}`, membership?.payments[i]?.totalAmount);
        setValue2(
          `paymentAmountBsS${i}`,
          membership?.payments[i]?.totalAmountInBsS?.toFixed(2)
        );
        Promise.allSettled([getPaymentMethods()]).then((r) => {
          setValue2(`paymentMethod${i}`, membership?.payments[i]?.methodId);
        });
        setValue2(`paymentMethod${i}`, membership?.payments[i]?.methodId);
        setValue2(`paymentReference${i}`, membership?.payments[i]?.reference);
        setValue2(
          `casheaReference${i}`,
          membership?.payments[i]?.referenceCashea
        );
      }
    }

    if (membership?.paymentType === paymentType?.FINANCIADO) {
      Promise.all([getPaymentMethods(), getDollarRate()]).then((r) => {
        const paymentDues = membership?.paymentDues || [];
        const payments = membership?.payments || [];

        paymentDues.forEach((due, i) => {
          const selectedPayment = payments.find(
            (p) => p?._id === due?.payment[0]
          );

          if (selectedPayment) {
            setValue2(`paymentDues[${i}].amount`, selectedPayment.totalAmount);
            setValue2(
              `paymentDues[${i}].amountBs`,
              selectedPayment.totalAmountInBsS?.toFixed(2)
            );
            setValue2(`paymentDues[${i}].reference`, selectedPayment.reference);
            setValue2(
              `paymentDues[${i}].paymentMethod`,
              selectedPayment?.methodId
            );
          } else {
            setValue2(`paymentDues[${i}].amount`, due?.amount?.toFixed(2));
            setValue2(
              `paymentDues[${i}].amountBs`,
              (due?.amount * dollarRate)?.toFixed(2)
            );
            setValue2(`paymentDues[${i}].paymentMethod`, due?.paymentMethod);
          }

          setValue2(
            `paymentDues[${i}].payment`,
            due?.payment[0] ? 'Pago realizado' : 'Cuenta por cobrar'
          );

          setValue2(
            `paymentDues[${i}].paymentDate`,
            due?.paymentDate
              ? moment(due?.paymentDate).format('DD/MM/YYYY')
              : ''
          );
          setValue2(
            `paymentDues[${i}].dueDate`,
            due?.dueDate ? moment(due?.dueDate).format('DD/MM/YYYY') : ''
          );
        });
      });
    }
  };

  let loadPaymentForms = (params, paymentMethods) => {
    let payments = [];
    // lOOP through every payment method
    for (let i = 1; i <= parseInt(paymentMethods); i++) {
      let data = {};

      if (i === 1 && params?.igtf1) {
        data.igtf = true;
      }
      if (i === 2 && params?.igtf2) {
        data.igtf = true;
      }
      let amount1IGTF = NaNtoNumber(parseFloat(watch3('amount1IGTF')));
      let amount1_2IGTF = NaNtoNumber(parseFloat(watch3('amount1_2IGTF')));
      let amount2IGTF = NaNtoNumber(parseFloat(watch3('amount2IGTF')));

      data.amountIGTF = parseFloat(params[`amount` + i.toString()]);

      // Add IGTF 1 and raise flag
      if (i === 1 && amount1IGTF > 0) {
        data.igtf = true;
        data.amountIGTF =
          amount1IGTF + parseFloat(params[`amount` + i.toString()]);
      }

      // Add IGTF 1 in 2 or 2 and raise flag
      if (i !== 1 && (amount1_2IGTF > 0 || amount2IGTF > 0)) {
        data.igtf = true;
        data.amountIGTF =
          amount2IGTF + parseFloat(params[`amount` + i.toString()]);

        if (watch3('mix')) {
          data.amountIGTF = data.amountIGTF + amount1_2IGTF;
        }
      }

      data.amountIGTF = data.amountIGTF?.toFixed(2);

      data.method = params[`method` + i.toString()];
      data.reference = params[`reference` + i.toString()];
      data.transactionBatch = params[`transactionBatch` + i.toString()];
      data.amount = params[`amount` + i.toString()];
      data.amountBsS = params[`amountBsS` + i.toString()];
      data.owner = params[`owner` + i.toString()];

      payments.push({
        ...data,
      });
    }

    // "REmove unwanted params from JSON"
    let words = [
      'method',
      'reference',
      'transactionBatch',
      'amount',
      'amountBsS',
      'paymentMethod',
      'igtf',
      'amountIGTF',
    ];
    for (const key in params) {
      for (var i = 0, ln = words.length; i < ln; i++) {
        if (key.indexOf(words[i]) !== -1) {
          delete params[key];
        }
      }
    }
    params.payments = payments;
    return params;
  };

  const appendFile = (data, paymentMethodsQuantity, tipodePago, price) => {
    const formData = new FormData();
    formData.append('paymentType', data?.paymentType);
    formData.append('membership', membership?._id);

    for (var i = 0; i < data?.payments.length; i++) {
      formData.append(`payments[${i}][amount]`, data?.payments[i].amountIGTF);

      if (data?.payments[i]?.igtf && returnIGTF() > 0) {
        formData.append(`payments[${i}][igtf]`, data?.payments[i]?.igtf);
      }

      formData.append(
        `payments[${i}][amountBsS]`,
        (data?.payments[i].amountIGTF * dollarRate)?.toFixed(2)
      );
      formData.append(`payments[${i}][method]`, data?.payments[i].method);
      if (
        data?.payments[i].reference ||
        data?.payments[i].reference !== undefined
      ) {
        formData.append(
          `payments[${i}][reference]`,
          data?.payments[i].reference
        );
      }
      if (
        data?.payments[i]?.transactionBatch !== undefined &&
        data?.payments[i]?.transactionBatch !== ''
      ) {
        formData.append(
          `payments[${i}][transactionBatch]`,
          data?.payments[i]?.transactionBatch
        );
      }
      if (
        isPaymentMethodZelleOrPaypal(data?.payments[i]?.method, paymentMethods)
      ) {
        // for zelle payments
        formData.append(`payments[${i}][accHolder]`, data?.payments[i]?.owner);
      }
    }

    // Load as many files as payment methods we have
    if (
      fileUploaded.length !== parseFloat(paymentMethodsQuantity) &&
      parseFloat(paymentMethodsQuantity) > 0 &&
      MethodValidation(data?.payments, fileUploaded, paymentMethods)
    ) {
      notify('Ingrese comprobantes de pago', 'info');
      return null;
    }

    if (parseFloat(price) && tipodePago !== paymentType?.FINANCIADO) {
      let totalSum = 0;
      for (let i = 0; i < data?.payments.length; i++) {
        totalSum = totalSum + parseFloat(data?.payments[i].amount);
      }
      if (totalSum < parseFloat(price)) {
        notify(
          'Monto a pagar por el cliente y suma de los pagos no coinciden',
          'info'
        );
        return null;
      }
    }

    for (let i = 0; i < parseInt(paymentMethodsQuantity); i++) {
      if (fileUploaded[i]) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }
    }

    return formData;
  };

  const payRewenMembership = handleSubmit3(async (data) => {
    let dataToPost = { ...data };
    dataToPost = loadPaymentForms(dataToPost, watch3('paymentMethods'));
    let fileToPost = appendFile(
      dataToPost,
      getValues3('paymentMethods'),
      watch3('paymentType'),
      watch3('price')
    );
    if (!isLoading && fileToPost) {
      setIsLoading(true);
      paymentsService
        .createMembershipPayment(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago registrado con exito`, 'success');
            closePaymentModal();
            // history.push('/services');
            setIsLoading(false);
            reloadMembership();
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const getCashReceivers = () => {
    cashReceiverService
      .getCashReceivers()
      .then((response) => {
        if (response.status === 200) {
          setCashReceiverOptions(response?.data?.cashReceivers);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((e) => {
        console.log('Error trayendo las cajas de efectivo', e);
      });
  };

  const payPendingPayment = handleSubmit3(async (data) => {
    let dataToPost = { ...data };
    // delete dataToPost?.price;
    dataToPost = loadPaymentForms(dataToPost, watch3('paymentMethods'));
    let fileToPost = appendFile(
      dataToPost,
      watch3('paymentMethods'),
      watch3('paymentType'),
      watch3('price')
    );
    if (!isLoading && fileToPost) {
      setIsLoading(true);
      paymentsService
        .createPendingPayment(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago pendiente registrado con exito`, 'success');
            closePaymentModal();
            reloadMembership();
            // history.push('/services');
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  // Change the firstPaymentDue, secondPaymentDue and thirdPaymentDue to paymentDuesN
  const updatePaymentDues = handleSubmit5(async (data) => {
    const paymentQuantity = membership?.paymentDues?.length - 1;
    let dataToPost = [];
    // Validate fields
    for (let j = 0; j < paymentQuantity; j++) {
      if (!watch5(`casheaDate${j}`)) {
        setError5(`casheaDate${j}`, {
          type: 'manual',
          message: 'Obligatorio',
        });
        return null;
      }
      if (!watch5(`casheaQuota${j}`)) {
        setError5(`casheaQuota${j}`, {
          type: 'manual',
          message: 'Obligatorio',
        });
        return null;
      }
      dataToPost.push({
        amount: parseFloat(watch5(`casheaQuota${j}`)),
        date: watch5(`casheaDate${j}`),
      });
    }

    const paymentDues = membership?.paymentDues || [];
    // Do not count the initial as quota
    const firstUnpaidIndex =
      paymentDues.findIndex((due) => due.payment.length === 0) - 1;

    let acumulated = 0;

    // Validate the sum of the quotas is equal to the debt
    for (
      let i = firstUnpaidIndex;
      i < membership?.paymentDues?.length - 1;
      i++
    ) {
      acumulated = acumulated + parseFloat(watch5(`casheaQuota${i}`));
    }

    if (
      parseFloat(acumulated.toFixed(2)) !== parseFloat(watch5('finalPrice'))
    ) {
      notify(
        'La suma de las cuotas no coincide con el precio de la membresia',
        'info'
      );
      return null;
    }

    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updatePaymentDues({ paymentDues: dataToPost }, membership?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Cuotas actualizadas con exito`, 'success');
            handleCloseEditPaymentDueModal();
            reloadMembership();
            // history.push('/services');
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const restorePaymentMethods = () => {
    if (parseFloat(watch3('price')) === 0) {
      for (let i = 0; i < parseInt(watch3('paymentMethods')); i++) {
        resetField3(`method${i}`);
        resetField3(`reference${i}`);
        resetField3(`paymentMethod${i}`);
        resetField3(`amount${i}`);
        resetField3(`amountBsS${i}`);
      }
      resetField3('paymentMethods');
    }
    // setValue3()
  };

  const handleAmountChange = (e, index) => {
    const { value } = e?.target;

    setValue3(`amountBsS${index}`, (value * dollarRate)?.toFixed(2));

    if (watch3('paymentType') === paymentType?.PENDING) {
      let quota2USD = parseFloat(watch3('price'));

      if (watch3('paymentMethods') > 1) {
        let amount2 = quota2USD - NaNtoNumber(parseFloat(watch3(`amount1`)));
        if (amount2 > 0 && amount2 < parseFloat(watch3('price'))) {
          setValue3('amount2', amount2);
          setValue3('amountBsS2', (amount2 * dollarRate)?.toFixed(2));
        }
      }

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (
        NaNtoNumber(parseFloat(watch3(`amount1`))) > parseFloat(watch3('price'))
      ) {
        notify('El montos excede el costo de la membresia', 'info');
        setValue3('amount1', '');
        setValue3('amountBsS1', '');
        return null;
      }

      if (quota2USD >= 0) {
        setValue3('quota2USD', quota2USD);
        setValue3('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('quota2USD', 0);
        setValue3('quota2BsS', 0);
        setValue3('amount1', '');
        setValue3('amountBsS1', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }

    if (watch3('paymentType') === paymentType?.DE_CONTADO) {
      let quota2USD = parseFloat(watch3('price'));

      setValue3(
        'amount2',
        quota2USD - NaNtoNumber(parseFloat(watch3(`amount1`)))
      );
      setValue3('amountBsS2', (watch3(`amount2`) * dollarRate)?.toFixed(2));

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (quota2USD >= 0) {
        setValue3('quota2USD', quota2USD);
        setValue3('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('quota2USD', 0);
        setValue3('quota2BsS', 0);
        setValue3('amount1', '');
        setValue3('amountBsS1', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }

    if (
      watch3('paymentType') === paymentType?.FINANCIADO &&
      [paymentModalTypes?.RENOVACION]?.includes(watch3('modal'))
    ) {
      let quota2USD = parseFloat(watch3('price'));

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (quota2USD > 0) {
        setValue3('quota2USD', quota2USD);
        setValue3('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('amount1', '');
        setValue3('amountBsS1', '');
        setValue3('quota2USD', 0);
        setValue3('quota2BsS', 0);
        notify('El monto de la segunda cuota debe ser mayor a 0$', 'info');
      }
    }

    if (
      watch3('paymentType') === paymentType?.FINANCIADO &&
      [paymentModalTypes?.PENDIENTE]?.includes(watch3('modal'))
    ) {
      let price = parseFloat(watch3('price'));

      setValue3(`amount2`, price - NaNtoNumber(parseFloat(watch3('amount1'))));
      setValue3(`amountBsS2`, (watch3('amount2') * dollarRate)?.toFixed(2));
    }
  };

  const handlePaymentMethodsChange = () => {
    if (parseFloat(watch3('paymentMethods')) === 2) {
      setValue3('mix', true);
      setValue3('method1', '');
      setValue3('amount1', '');
      setValue3('amountBsS1', '');
      setValue3('method2', '');
      setValue3('amount2', '');
      setValue3('amountBsS2', '');
    } else {
      setValue3('mix', false);
    }
  };

  const handleSecondAmountChange = (e, index) => {
    let method = paymentMethods?.filter(
      (o) => o?._id === watch3(`method${index}`)
    )[0];

    if (method && method?.currency !== 'BsS' && watch3('mix')) {
      setValue3(
        'amount2IGTF',
        ((watch3('amount2') * returnIGTF()) / 100)?.toFixed(2)
      );
    }

    setValue3('amountBsS2', (watch3('amount2') * dollarRate)?.toFixed(2));

    if (watch3('paymentType') === paymentType?.PENDING) {
      let quota2USD = parseFloat(watch3('price'));

      if (watch3('paymentMethods') > 1) {
        let amount1 = quota2USD - NaNtoNumber(parseFloat(watch3(`amount2`)));
        if (amount1 > 0 && amount1 < parseFloat(watch3('price'))) {
          setValue3('amount1', amount1);
          setValue3('amountBsS1', (watch3(`amount1`) * dollarRate)?.toFixed(2));
        }
      }

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (
        NaNtoNumber(parseFloat(watch3(`amount2`))) > parseFloat(watch3('price'))
      ) {
        notify('El montos excede el costo de la membresia', 'info');
        setValue3('amount2', '');
        setValue3('amountBsS2', '');
        return null;
      }

      if (quota2USD >= 0) {
        setValue3('quota2USD', quota2USD);
        setValue3('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('quota2USD', 0);
        setValue3('quota2BsS', 0);
        setValue3('amount1', '');
        setValue3('amountBsS1', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }

    if (watch3('paymentType') === paymentType?.DE_CONTADO) {
      let quota2USD = parseFloat(watch3('price'));

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (quota2USD >= 0) {
        setValue3('quota2USD', quota2USD);
        setValue3('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('quota2USD', 0);
        setValue3('quota2BsS', 0);
        setValue3('amount2', '');
        setValue3('amountBsS2', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }

    if (
      watch3('paymentType') === paymentType?.FINANCIADO &&
      [paymentModalTypes?.RENOVACION]?.includes(watch3('modal'))
    ) {
      let quota2USD = parseFloat(watch3('price'));

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (quota2USD > 0) {
        setValue3('quota2USD', quota2USD);
        setValue3('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('amount2', '');
        setValue3('amountBsS2', '');
        notify('El monto de la segunda cuota debe ser mayor a 0$', 'info');
      }
    }

    if (
      watch3('paymentType') === paymentType?.FINANCIADO &&
      [paymentModalTypes?.PENDIENTE]?.includes(watch3('modal'))
    ) {
      let quota2USD = parseFloat(watch3('price'));

      for (let i = 0; i < parseFloat(watch3('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch3(`amount${i + 1}`)));
      }

      if (quota2USD < 0) {
        setValue3(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch3('price'))) - 1
        );
        setValue3('quota2USD', 0);
        setValue3('quota2BsS', 0);
        setValue3('amount2', '');
        setValue3('amountBsS2', '');
        notify('La suma de los montos supera el costo a facturar', 'info');
      }
    }
  };

  const handleEditAmountChange = () => {
    setValue4('amountBsS', (watch4('amount') * dollarByDate)?.toFixed(2));
  };

  const handleEditBsChange = () => {
    setValue4('amount', (watch4('amountBsS') / dollarByDate)?.toFixed(2));
  };

  const handleAddAmountChange = () => {
    setValue6('amountBsS', (watch6('amount') * dollarByDate)?.toFixed(2));
  };

  const handleReturnedAmountChange = (i) => {
    setValue6(
      `amountReturnedBsS${i}`,
      (watch6(`amountReturned${i}`) * dollarByDate)?.toFixed(2)
    );
  };

  const handleMethodChange = (e) => {
    const currentMethod = getValues6('method');
    const currentAmount = getValues6('amount');
    const currentAmountBs = getValues6('amountBsS');
    reset6({
      method: currentMethod,
      amount: currentAmount,
      amountBsS: currentAmountBs,
    });
  };

  const handleAddBsChange = () => {
    setValue6('amount', (watch6('amountBsS') / dollarByDate)?.toFixed(2));
  };

  const handleDateChange = (e) => {
    setCreationDate(e);
    getDollarRateByDate(e);
  };

  const getDollarRateByDate = (date) => {
    let params = {
      currency: 'USD',
      date: moment(date).format('YYYY-MM-DD'),
      limit: 20,
    };

    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          setDollarByDate(response?.data?.result[0]?.rate);
          if (openEditPaymentModal.isOpen) {
            setValue4(
              'amountBsS',
              (watch4('amount') * response?.data?.result[0]?.rate)?.toFixed(2)
            );
          }
          if (openAddPaymentModal) {
            setValue6(
              'amountBsS',
              (watch6('amount') * response?.data?.result[0]?.rate)?.toFixed(2)
            );
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const getDollarRate = async () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
          setbsDisabled(true);

          if (membership?.paymentType === paymentType?.FINANCIADO) {
            setValue2(
              `paymentDues[0].amountBs`,
              (
                response?.data?.rate * membership?.paymentDues[0]?.amount
              )?.toFixed(2)
            );
            setValue2(
              `paymentDues[1].amountBs`,
              (
                response?.data?.rate * membership?.paymentDues[1]?.amount
              )?.toFixed(2)
            );
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const openMembershipPendingPaymentModal = () => {
    let url = `/afiliations/payment/${membership?._id}/duePayment/${parseUrl(
      membership?.paymentType
    )}`;
    history.push(url);
  };

  const handleOpenEditPaymentDueModal = () => {
    setOpenEditPaymentDueModal(true);
    if (membership.paymentDues.length > 0) {
      for (let i = 0; i < membership.paymentDues.length; i++) {
        setValue5(`casheaQuota${i}`, membership?.paymentDues[i + 1]?.amount);
        setValue5(
          `casheaDate${i}`,
          new Date(membership?.paymentDues[i + 1]?.dueDate)
        );
      }
    }

    if (
      [paymentType?.CASHEA, paymentType?.CASHEA_LINK].includes(
        membership?.paymentType
      )
    ) {
      setValue5('finalPrice', membership?.pendingToPay);
    } else {
      setValue5('finalPrice', getDuefromSuccessPayments(membership));
    }
  };

  const handleCloseEditPaymentDueModal = () => {
    setOpenEditPaymentDueModal(false);
  };

  const handlePaymentTypeForm = () => {
    if (watch3('paymentType') === paymentType?.DE_CONTADO) {
      setValue3('paymentMethods', 1);
      setValue3('amount1', watch3('price'));
      setValue3(
        'amountBsS1',
        (NaNtoNumber(parseFloat(watch3('price'))) * dollarRate)?.toFixed(2)
      );
    }

    if (watch3('paymentType') === paymentType?.FINANCIADO) {
      setValue3('paymentMethods', 1);
    }
  };

  const closePaymentModal = () => {
    setOpenPayModal(false);
    setFileUploaded([]);
    reset3();
  };

  const handleEditPaymentModal = (payment) => {
    console.log('payment', payment);
    setOpenEditPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !openEditPaymentModal?.isOpen,
        payment: payment ? payment : '',
      };
    });

    if (payment) {
      setValue4(
        'amount',
        payment?.igtfAmount
          ? payment?.totalAmount + payment?.igtfAmount
          : payment?.totalAmount
      );
      setValue4('igtfAmount', payment?.igtfAmount ? payment?.igtfAmount : 0);
      setValue4('igtf', payment?.igtfAmount ? payment?.igtfAmount : 0);
      setValue4('amountBsS', payment?.totalAmountInBsS?.toFixed(2));
      setValue4('method', payment?.methodId);
      setValue4('phone', payment?.clientPhone);
      setValue4('paymentType', payment?.paymentType);
      setValue4('bank', payment?.clientBankCode);
      setValue4('reference', payment?.reference);
      setValue4('transactionBatch', payment?.transactionBatch || '');
      setValue4('observation', payment?.observation);
      setValue4('referenceCashea', payment?.referenceCashea);
      setValue4('cashReceiver', payment?.cashReceiverId);
      setValue4('accHolder', payment?.accHolder);
      let fecha = new Date(payment?.createdAt);
      setCreationDate(fecha?.setDate(fecha.getDate()));
      getDollarRateByDate(fecha);
    } else {
      reset4();
    }
  };

  const handleAddPaymentModal = () => {
    setOpenAddPaymentModal(!openAddPaymentModal);
    setAddFilesUploaded([]);
    setCreationDate(new Date());
    reset6();
  };

  useEffect(() => {
    getDollarRate();
    getPaymentMethods();
    preloadForm();
  }, [open, membership]);

  useEffect(() => {
    getDollarRateByDate(new Date());
    getCashReceivers();
  }, []);

  const editPayment = handleSubmit4(async (data) => {
    if (!validateUpdatePaymentRefLenght(data, setError4, paymentMethods))
      return null;

    const formData = new FormData();
    formData.append('membership', membership?._id);
    formData.append(`payments[0][id]`, openEditPaymentModal?.payment?._id);
    formData.append(`payments[0][method]`, watch4(`method`));
    if (watch4(`accHolder`)) {
      formData.append(`payments[0][accHolder]`, watch4(`accHolder`));
    }
    if (watch4(`phone`)) {
      formData.append(`payments[0][phone]`, watch4(`phone`));
    }
    if (watch4(`bank`)) {
      formData.append(`payments[0][bank]`, watch4(`bank`));
    }
    if (watch4(`cashReceiver`)) {
      formData.append(`payments[0][cashReceiver]`, watch4(`cashReceiver`));
    }
    if (watch4(`paymentType`)) {
      formData.append(`paymentType`, watch4(`paymentType`));
    }

    formData.append(`payments[0][reference]`, watch4(`reference`));
    if (watch4(`transactionBatch`) !== '' && watch4(`transactionBatch`) !== undefined) {
      formData.append(`payments[0][transactionBatch]`, watch4(`transactionBatch`));
    }
    formData.append(
      `payments[0][amount]`,
      watch4(`igtfAmount`)
        ? NaNtoNumber(parseFloat(watch4(`amount`))) -
        NaNtoNumber(parseFloat(watch4(`igtfAmount`)))
        : NaNtoNumber(parseFloat(watch4(`amount`)))
    );
    formData.append(
      `payments[0][igtfAmount]`,
      NaNtoNumber(parseFloat(watch4(`igtfAmount`)))
    );
    formData.append(`payments[0][observation]`, watch4(`observation`));
    formData.append(
      `payments[0][igtf]`,
      parseFloat(watch4(`igtfAmount`)) > 0 ? true : false
    );
    formData.append(`payments[0][amountBsS]`, watch4(`amountBsS`));
    formData.append(
      `payments[0][creationDate]`,
      moment(creationDate)?.format('YYYY-MM-DD')
    );
    if (
      [paymentType?.CASHEA, paymentType?.CASHEA_LINK].includes(
        membership?.paymentType
      )
    ) {
      formData.append(
        `payments[0][referenceCashea]`,
        watch4(`referenceCashea`)
      );
    }

    if (!isLoading && formData) {
      setIsLoading(true);
      paymentsService
        .editPayment(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago editado con exito`, 'success');
            handleEditPaymentModal();
            reloadMembership();
            setIsLoading(false);
            setTimeout(() => {
              window.location.reload();
            }, 1200);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const isBancamigaPM = (options, method) => {
    let PMpaymentMethod = filterById(options, method);

    if (PMpaymentMethod?.name === methodNames.PAGO_MÓVIL_BANCAMIGA) {
      return true;
    } else {
      return false;
    }
  };

  const showPaymentCashback = () => {
    const cash = filterById(paymentMethods, watch6('method'));
    if (
      [
        methodNames.CASH_BS,
        methodNames.CASH_EUR,
        methodNames.CASH_USD,
      ].includes(cash?.name)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const showAccHolder = () => {
    const payment = filterById(paymentMethods, watch6('method'));
    if ([methodNames.ZELLE, methodNames.PAYPAL].includes(payment?.name)) {
      return true;
    } else {
      return false;
    }
  };

  const isChangeVoucherRequired = (i) => {
    const payment = filterById(
      paymentMethods,
      watch6(`amountReturnedMethod${i}`)
    );
    if (
      [
        methodNames.CASH_BS,
        methodNames.CASH_EUR,
        methodNames.CASH_USD,
        methodNames.PUNTO_DE_VENTA,
      ].includes(payment?.name)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const validateBancamigaPM = async (data) => {
    return bancamigaService
      .checkPayment(data)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.wasFound) {
            return true;
          } else {
            notify(`No se pudo validar el pago movil`, 'error');
            return false;
          }
        } else {
          notify(`${response.message}`, 'error');
          return false;
        }
      })
      .catch(() => { });
  };

  const addPayment = handleSubmit6(async (data) => {
    const formData = new FormData();
    formData.append('paymentType', data?.paymentType);
    formData.append(`payments[0][method]`, watch6(`method`));
    if (watch6(`phone`)) {
      formData.append(`payments[0][phone]`, watch6(`phone`));
    }
    if (watch6(`bank`)) {
      formData.append(`payments[0][bank]`, watch6(`bank`));
    }

    formData.append(`payments[0][reference]`, watch6(`reference`));
    if (watch6(`transactionBatch`) !== '' && watch6(`transactionBatch`) !== undefined) {
      formData.append(`payments[0][transactionBatch]`, watch6(`transactionBatch`));
    }
    if (showAccHolder()) {
      formData.append(`payments[0][accHolder]`, watch6(`reference`));
    }
    if (watch6(`cashReceiver`)) {
      formData.append(`payments[0][cashReceiver]`, watch6(`cashReceiver`));
    }
    formData.append(
      `payments[0][amount]`,
      watch4(`igtfAmount`)
        ? NaNtoNumber(parseFloat(watch6(`amount`))) -
        NaNtoNumber(parseFloat(watch6(`igtfAmount`)))
        : NaNtoNumber(parseFloat(watch6(`amount`)))
    );
    formData.append(
      `payments[0][igtfAmount]`,
      NaNtoNumber(parseFloat(watch6(`igtfAmount`)))
    );
    formData.append(
      `payments[0][igtf]`,
      parseFloat(watch6(`igtfAmount`)) > 0 ? true : false
    );
    formData.append(`payments[0][amountBsS]`, watch6(`amountBsS`));
    if (creationDate) {
      formData.append(
        `payments[0][date]`,
        moment(creationDate)?.format('YYYY-MM-DD')
      );
    }
    if (addFilesUploaded[0]) {
      formData.append(`paymentEvidence`, addFilesUploaded[0]);
      formData.append(`payments[0][hasEvidence]`, true);
    }

    if (showPaymentCashback() && !watch6('amountPaid')) {
      notify('El monto recibido es obligatiorio', 'error');
      return;
    }
    let amountReturned = 0;
    if (
      showPaymentCashback() &&
      watch6('amountPaid') &&
      Number(watch6('amountPaid')) > Number(watch6('amount'))
    ) {
      for (let i = 0; i < watch6('amountReturnedQuantity'); i++) {
        amountReturned += parseFloat(watch6(`amountReturned${i}`));
        // Monto USD
        if (!watch6(`amountReturned${i}`)) {
          notify(`El Monto de vuelto USD ${i + 1} es obligatorio`, 'error');
          return;
        }
        // cant return negatives
        if (watch6(`amountReturned${i}`) < 0) {
          notify(
            `El Monto de vuelto USD ${i + 1} no puede ser negativo`,
            'error'
          );
          return;
        }
        formData.append(
          `paymentChanges[${i}][amount]`,
          watch6(`amountReturned${i}`)
        );

        // Monto BsS
        if (!watch6(`amountReturnedBsS${i}`)) {
          notify(`El Monto de vuelto Bs${i + 1} es obligatorio`, 'error');
          return;
        }

        // cant return negatives
        if (watch6(`amountReturnedBsS${i}`) < 0) {
          notify(
            `El Monto de vuelto BsS ${i + 1} no puede ser negativo`,
            'error'
          );
          return;
        }
        // Monto BsS
        formData.append(
          `paymentChanges[${i}][amountBsS]`,
          watch6(`amountReturnedBsS${i}`)
        );

        // Método
        if (!watch6(`amountReturnedMethod${i}`)) {
          notify(`El Metodo de vuelto ${i + 1} es obligatorio`, 'error');
          return;
        }
        formData.append(
          `paymentChanges[${i}][method]`,
          watch6(`amountReturnedMethod${i}`)
        );

        // Referencia
        if (isChangeVoucherRequired(i)) {
          if (!watch6(`amountReturnedRef${i}`)) {
            notify(`La referencia de vuelto ${i + 1} es obligatoria`, 'error');
            return;
          }
          formData.append(
            `paymentChanges[${i}][ref]`,
            watch6(`amountReturnedRef${i}`)
          );
        } else {
          // Si no es cash ni punto de venta, solo agrega si existe
          if (watch6(`amountReturnedRef${i}`)) {
            formData.append(
              `paymentChanges[${i}][ref]`,
              watch6(`amountReturnedRef${i}`)
            );
          }
        }

        // Comprobante
        if (isChangeVoucherRequired(i)) {
          if (!returnsFilesUploaded[i]) {
            notify(
              `El comprobante de pago de vuelto ${i + 1} es obligatorio`,
              'error'
            );
            return;
          }
          formData.append(`paymentChanges[${i}][hasEvidence]`, true);
          formData.append(`paymentChangeEvidence`, returnsFilesUploaded[i]);
        } else {
          if (returnsFilesUploaded[i]) {
            formData.append(`paymentChanges[${i}][hasEvidence]`, true);
            formData.append(`paymentChangeEvidence`, returnsFilesUploaded[i]);
          }
        }

        formData.append(`paymentChanges[${i}][paid]`, watch6(`amountPaid`));
      }
    }

    if (
      watch6('amountPaid') &&
      amountReturned.toFixed(2) !==
      (Number(watch6('amountPaid')) - Number(watch6('amount'))).toFixed(2)
    ) {
      notify(
        'La suma de los vueltos no coincide con el monto restante.',
        'error'
      );
      return;
    }

    if (isBancamigaPM(paymentMethods, watch6('method'))) {
      let PMData = {
        date: creationDate ? moment(creationDate).format('YYYY-MM-DD') : '',
        bank: watch6(`bank`) ? watch6(`bank`) : '',
        phone: watch6(`phone`) ? '58' + watch6(`phone`) : '',
        reference: watch6(`reference`),
        method: watch6(`method`),
      };
      const validate = await validateBancamigaPM(PMData);

      if (validate) {
        if (!isLoading && formData) {
          setIsLoading(true);
          paymentsService
            .addMembershipPayment(membership?._id, formData)
            .then((response) => {
              if ([200, 201].includes(response.status)) {
                notify(`Pago Realizado con exito`, 'success');
                reloadMembership();
                handleAddPaymentModal();
                setIsLoading(false);
                setTimeout(() => {
                  window.location.reload();
                }, 1200);
              } else {
                notify(`${response.message}`, 'error');
                setIsLoading(false);
              }
            })
            .catch((error) => {
              setIsLoading(false);
            });
        }
      } else {
        return false;
      }
    } else {
      if (!isLoading && formData) {
        setIsLoading(true);
        paymentsService
          .addMembershipPayment(membership?._id, formData)
          .then((response) => {
            if ([200, 201].includes(response.status)) {
              notify(`Pago creado con exito`, 'success');
              reset6();
              handleAddPaymentModal();
              setIsLoading(false);
              setTimeout(() => {
                window.location.reload();
              }, 1200);
            } else {
              notify(`${response.message}`, 'error');
              setIsLoading(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }
  });

  const Paymentaction = () => {
    if (watch3('modal') === paymentModalTypes?.PENDIENTE) {
      return payPendingPayment;
    }
    if (watch3('modal') === paymentModalTypes?.RENOVACION) {
      return payRewenMembership;
    }
  };

  // Internal counter cant see affiliation cards
  if (
    [salesRoles?.SALES_COUNTER].includes(authService?.getUserType()) &&
    membership?.membershipStatus === planStatus?.INCOMPLETED &&
    authService?.getUser()?.type === userType?.INTERNO
  ) {
    return null;
  }

  // Admin Aux cant see affiliation card
  if (
    [salesRoles?.SALES_ADMIN_AUX].includes(authService?.getUserType()) &&
    membership?.membershipStatus === planStatus?.INCOMPLETED
  ) {
    return null;
  }

  const compareBillingPaid = () => {
    let paid = 0;
    let paymentDueAmount = 0;
    let membershipPaymentAmount = 0;

    membership?.payments?.forEach((payment) => {
      paid = paid + payment?.totalAmount;
    });

    if (
      membership?.siblingMemberships &&
      membership?.siblingMemberships.length > 0
    ) {
      if (
        [
          paymentType?.FINANCIADO,
          paymentType?.CASHEA,
          paymentType?.CASHEA_LINK,
        ].includes(membership?.paymentType)
      ) {
        membership?.paymentDues.forEach((due) => {
          if (due?.payment && due?.payment?.length === 0) {
            paymentDueAmount = paymentDueAmount + due.amount;
          }
        });

        membership.siblingMemberships.forEach((mem) => {
          membershipPaymentAmount += mem?.priceInfo?.finalPrice;
        });
        membershipPaymentAmount += membership?.priceInfo?.finalPrice;

        if (paid < membershipPaymentAmount - paymentDueAmount) {
          return true;
        } else {
          return false;
        }
      } else {
        membership.siblingMemberships.forEach((mem) => {
          membershipPaymentAmount += mem?.priceInfo?.finalPrice;
        });
        membershipPaymentAmount += membership?.priceInfo?.finalPrice;
        if (paid < membershipPaymentAmount) {
          return true;
        } else {
          return false;
        }
      }
    }

    membership?.paymentDues.forEach((due) => {
      if (due?.payment && due?.payment?.length === 0) {
        paymentDueAmount = paymentDueAmount + due.amount;
      }
    });

    if (membership?.paymentDues && membership?.paymentDues?.length > 0) {
      if (paid < membership?.priceInfo?.finalPrice - paymentDueAmount) {
        return true;
      } else {
        return false;
      }
    } else {
      if (paid < membership?.priceInfo?.finalPrice) {
        return true;
      } else {
        return false;
      }
    }
  };

  const handleReturns = (length) => {
    let change = 0;

    change = watch6('amountPaid') - watch6('amount');

    Array.from({ length }).forEach((item, i) => {
      setValue6(`amountReturned${i}`, (change / length).toFixed(2));
      setValue6(
        `amountReturnedBsS${i}`,
        ((change / length) * dollarByDate).toFixed(2)
      );
    });
  };

  const handleEditAmountChangeInput = (changedIndex) => {
    const amountReturnedMethods = Number(watch6('amountReturnedQuantity'));
    const amountPaid = Number(watch6('amountPaid')) || 0;
    const amount = Number(watch6('amount')) || 0;
    const changes = amountPaid - amount;

    // Obtén los valores actuales de los vueltos
    let changesArr = [];
    let filledCount = 0;

    for (let i = 0; i < amountReturnedMethods; i++) {
      const val = Number(watch6(`amountReturned${i}`));
      if (!isNaN(val) && val !== 0) {
        changesArr[i] = val;
        filledCount++;
      } else {
        changesArr[i] = 0;
      }
    }

    // Si solo hay un vuelto, asigna todo
    if (amountReturnedMethods === 1) {
      setValue6(`amountReturned0`, changes.toFixed(2));
      setValue6(`amountReturnedBsS0`, (changes * dollarByDate).toFixed(2));
      return;
    }

    // Si todos menos el último están llenos, ajusta el último
    let sumExceptLast = 0;
    for (let i = 0; i < amountReturnedMethods - 1; i++) {
      sumExceptLast += Number(watch6(`amountReturned${i}`)) || 0;
    }
    const lastIndex = amountReturnedMethods - 1;
    const lastValue = changes - sumExceptLast;

    // Si el usuario está editando el último, solo actualiza su BsS
    if (changedIndex === lastIndex) {
      setValue6(
        `amountReturnedBsS${lastIndex}`,
        (changesArr[lastIndex] * dollarByDate).toFixed(2)
      );
      return;
    }

    // Si el usuario edita cualquier otro, ajusta el último para que cuadre la suma
    for (let i = 0; i < amountReturnedMethods; i++) {
      if (i === lastIndex) {
        setValue6(`amountReturned${i}`, lastValue.toFixed(2));
        setValue6(
          `amountReturnedBsS${i}`,
          (lastValue * dollarByDate).toFixed(2)
        );
      } else {
        setValue6(
          `amountReturnedBsS${i}`,
          (changesArr[i] * dollarByDate).toFixed(2)
        );
      }
    }
  };

  return (
    <>
      <LoadSpinner show={isLoading} />
      <PaymentModal
        show={openPayModal}
        register={register3}
        openPayModal={openPayModal}
        handleClose={() => closePaymentModal()}
        payRewenMembership={Paymentaction()}
        errors={errors3}
        control={control3}
        setValue={setValue3}
        options={{
          paymentMethods: paymentMethods,
          paymentTypesOptions: [
            ...paymentTypesOptions,
            // { name: 'Cashea', _id: 'Cashea' },
          ],
          dollarRate: dollarRate,
        }}
        onChange={{
          handlePaymentTypeForm: handlePaymentTypeForm,
          restorePaymentMethods: restorePaymentMethods,
          handleAmountChange: handleAmountChange,
          handleSecondAmountChange: handleSecondAmountChange,
          handlePaymentMethodsChange: handlePaymentMethodsChange,
        }}
        watch={watch3}
        setFileUploaded={setFileUploaded}
        fileUploaded={fileUploaded}
        bsDisabled={bsDisabled}
        membership={membership}
      />

      <EditPaymentDuesModal
        show={openEditPaymentDueModal}
        handleClose={() => handleCloseEditPaymentDueModal()}
        register={register5}
        getValues={getValues5}
        errors={errors5}
        setError={setError5}
        watch={watch5}
        setValue={setValue5}
        control={control5}
        reset={reset5}
        membership={membership}
        action={updatePaymentDues}
      />

      <EditPaymentModal
        modal={openEditPaymentModal}
        register={register4}
        openPayModal={openPayModal}
        action={editPayment}
        handleClose={() => handleEditPaymentModal()}
        payRewenMembership={Paymentaction()}
        paymentType={membership?.paymentType}
        errors={errors4}
        setValue={setValue4}
        control={control4}
        options={{
          paymentMethods: paymentMethods,
          paymentTypesOptions: [
            ...paymentTypesOptions,
            { name: 'Cashea', _id: 'Cashea' },
            ...(casheaLinkAllowedRoles.includes(authService?.getUserType())
              ? [{ name: 'Cashea Link', _id: paymentType?.CASHEA_LINK }]
              : []),
          ],
          dollarRate: dollarRate,
          cashReceivers: cashReceiverOptions,
        }}
        creationDate={creationDate}
        onChange={{
          handleEditAmountChange: handleEditAmountChange,
          handleEditBsChange: handleEditBsChange,
          handleDateChange: handleDateChange,
        }}
        watch={watch4}
      />

      <AddPaymentModal
        modal={openAddPaymentModal}
        register={register6}
        action={addPayment}
        handleClose={() => handleAddPaymentModal()}
        paymentType={membership?.paymentType}
        errors={errors6}
        setValue={setValue6}
        control={control6}
        options={{
          paymentMethods: paymentMethods,
          paymentTypesOptions: paymentTypesOptions,
          dollarRate: dollarRate,
          cashReceivers: cashReceiverOptions,
        }}
        creationDate={creationDate}
        onChange={{
          handleEditAmountChange: handleAddAmountChange,
          handleEditBsChange: handleAddBsChange,
          handleDateChange: handleDateChange,
          handleReturnedAmountChange: handleReturnedAmountChange,
          handleMethodChange: handleMethodChange,
          handleReturns: handleReturns,
          handleEditAmountChangeInput: handleEditAmountChangeInput,
        }}
        watch={watch6}
        filesUploaded={returnsFilesUploaded}
        addFilesUploaded={addFilesUploaded}
        setFilesUploaded={setReturnsFilesUploaded}
        setAddFilesUploaded={setAddFilesUploaded}
        showPaymentCashback={showPaymentCashback}
        showAccHolder={showAccHolder}
      />

      <div className="order-card">
        <OderCardHeader open={open} setOpen={setOpen} label={label} />

        {membership.mainMembership ? (
          <h6 style={{ marginTop: '24px' }}>
            El Ingreso de esta orden se encuentra reflejado en:
            <a
              style={{ textDecoration: 'none' }}
              href={`/afiliations/edit-order/${membership.mainMembership?._id}`}
            >
              {' ' + membership.mainMembership?.membershipId}
            </a>
          </h6>
        ) : (
          ''
        )}
        {open && (
          <>
            <PaymentsTable
              role={authService?.getUserType()}
              header={
                [paymentType?.CASHEA, paymentType?.CASHEA_LINK].includes(
                  membership?.paymentType
                )
                  ? casheaPaymentsTableHeader
                  : paymentsTableHeader
              }
              membership={membership}
              handleEditPaymentModal={handleEditPaymentModal}
            />

            {membership.siblingMemberships.length > 0 && (
              <>
                <h6>
                  Este ingreso corresponde a las ordenes:{' '}
                  {membership?.membershipId} -{' '}
                  {membership.siblingMemberships.map((m, i) => (
                    <SiblingMembershipsLink
                      membership={m}
                      last={i === membership.siblingMemberships.length - 1}
                    />
                  ))}
                </h6>
              </>
            )}
            {!membership.mainMembership && !allowEditPayment() && (
              <div
                style={{
                  marginTop: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  width: '100%',
                  justifyContent: 'flex-start',
                }}
              >
                <Input
                  type={'checkbox'}
                  subLabel={'Factura N°'}
                  name="hasInvoiceNumber"
                  register={register7}
                  value={membership?.hasInvoiceNumber}
                  errors={errors7?.hasInvoiceNumber?.message}
                  disabled={allowEditPayment()}
                />
                {/* Input propio (sin espaciador de label ni <p> de error) para que
                    quede centrado con el checkbox y el botón */}
                <div
                  className="input-component-container"
                  style={{ margin: 0, position: 'relative' }}
                >
                  <input
                    id="invoiceNumber"
                    type="text"
                    autoComplete="off"
                    className={errors7?.invoiceNumber?.message ? 'error-input' : ''}
                    disabled={!watch7('hasInvoiceNumber')}
                    {...register7('invoiceNumber')}
                  />
                  {errors7?.invoiceNumber?.message && (
                    <p
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        margin: 0,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {errors7?.invoiceNumber?.message}
                    </p>
                  )}
                </div>
                {!allowEditPayment() && (
                  <ActionButton
                    label="Agregar Factura"
                    action={() => {
                      loadinvoiceNumber();
                    }}
                    disabled={!watch7('hasInvoiceNumber')}
                  />
                )}
              </div>
            )}
            {!membership.mainMembership &&
              membership?.paymentType !== 'Cortesia' &&
              compareBillingPaid() && (
                <div style={{ marginTop: '12px' }}>
                  <ActionButton
                    label="Agregar pago"
                    action={() => {
                      handleAddPaymentModal();
                    }}
                  />
                </div>
              )}

            <PendingPaymentsTable
              header={pendingPaymentsTableHeader}
              membership={membership}
              dollarRate={dollarRate}
              openMembershipPendingPaymentModal={
                openMembershipPendingPaymentModal
              }
              handleOpenEditPaymentDueModal={() =>
                handleOpenEditPaymentDueModal()
              }
              openEditPaymentDueModal={openEditPaymentDueModal}
            />
          </>
        )}
      </div>
    </>
  );
};

export const FinancedPaymentForm = (props) => {
  const {
    membership,
    register2,
    errors2,
    watch2,
    options,
    action,
    editPendingPayment,
    handleDueAmountChange = { handleDueAmountChange },
  } = props;

  const getPaymentsRef = (membership, i) => {
    let selectedRef = membership?.payments?.filter(
      (p) => p?._id === membership?.paymentDues[i]?.payment[0]
    );

    if (selectedRef?.length > 0) {
      return (
        <div className="row">
          <Input
            bootstrap={'col-6'}
            label={'Referencia'}
            type={'text'}
            options={options?.paymentMethods}
            name={`paymentDues[${i}].reference`}
            register={register2}
            placeholder={''}
            errors={errors2?.[`paymentDues[${i}].reference`]?.message}
            disabled={allowEditPayment()}
          />
          <div className="col-6">
            <div className="ref-image-container">
              {selectedRef[0]?.referenceImg && (
                <a
                  target="_blank"
                  href={selectedRef[0]?.referenceImg}
                  rel="noreferrer"
                >
                  <h6>Ver Comprobante</h6>
                </a>
              )}
            </div>
          </div>
          {allowAdmin && (
            <div style={{ marginBottom: '12px' }} className="col-6">
              <ActionButton
                label={'Editar Pago'}
                action={() => editPendingPayment(i)}
              />
            </div>
          )}
        </div>
      );
    } else return null;
  };

  if (membership?.paymentDues?.length > 0) {
    return (
      <>
        {membership?.paymentDues?.map((m, i) => (
          <div className="row">
            <div className="light-gray-line"></div>
            <h6>
              Cuota ({i + 1}){' '}
              {membership?.paymentDues[i].dueDate
                ? moment(membership?.paymentDues[i].dueDate).format(
                  'DD/MM/YYYY'
                )
                : ''}
            </h6>
            <Input
              bootstrap={'col-6'}
              label={'Monto'}
              type={'number'}
              name={`paymentDues[${i}].amount`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].amount`]?.message}
              min={1}
              max={2}
              onChange={handleDueAmountChange(
                watch2(`paymentDues[${i}].amount`),
                watch2(`paymentDues[${i}].payment`),
                i
              )}
              disabled={allowEditPayment()}
            />{' '}
            <Input
              bootstrap={'col-6'}
              label={'Monto bolivares'}
              type={'number'}
              name={`paymentDues[${i}].amountBs`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].amountBs`]?.message}
              min={1}
              max={2}
              disabled={allowEditPayment()}
            />
            <Input
              bootstrap={'col-6'}
              label={'Metodo de Pago'}
              type={'select'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].paymentMethod`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].paymentMethod`]?.message}
              disabled={allowEditPayment()}
            />{' '}
            <Input
              bootstrap={'col-6'}
              label={'Estatus de Pago'}
              type={'text'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].payment`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].payment`]?.message}
              disabled={true}
            />
            {getPaymentsRef(membership, i)}
            <Input
              bootstrap={'col-6'}
              label={'Fecha de Pago'}
              type={'text'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].paymentDate`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].paymentDate`]?.message}
            />
            <Input
              bootstrap={'col-6'}
              label={'Fecha de Corte'}
              type={'text'}
              options={options?.paymentMethods}
              name={`paymentDues[${i}].dueDate`}
              register={register2}
              placeholder={''}
              errors={errors2?.[`paymentDues[${i}].dueDate`]?.message}
              disabled={true}
            />
            {(m?.payment?.length === 0 || !m?.payment) && (
              <ActionButton label={'Realizar pago pendiente'} action={action} />
            )}
            <br />
          </div>
        ))}
      </>
    );
  } else return null;
};

export const SiblingMembershipsLink = ({ membership, last }) => {
  return (
    <>
      <a
        style={{ textDecoration: 'none' }}
        href={`/afiliations/edit-order/${membership?._id}`}
      >
        <b>{membership.membershipId}</b>
      </a>
      {!last ? '-' : ''}
    </>
  );
};
